import { createAction, props } from '@ngrx/store';
import { Language } from '../../types/data-model';

export const add = createAction('ADD_LANGUAGE', props<{ lang: Language }>());
export const remove = createAction('REMOVE_LANGUAGE', props<{ lang: Language }>());
